import { AppBar, Toolbar, Box, Typography, useMediaQuery, Button, IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import cs from 'classnames';
import { useTranslation } from 'react-i18next';
import useBasicStyles from '../../../layouts/BasicLayout/useBasicStyles';
import useCommonStyles from '../../../useCommonStyles';

export type VehicleDiagramHeaderProps = {
    goToView: () => void;
};

const VehicleDiagramHeader = ({ goToView }: VehicleDiagramHeaderProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage', 'common']);
    const commonStyles = useCommonStyles();
    const basicStyles = useBasicStyles();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    if (isSmall) {
        return (
            <AppBar
                className={cs(basicStyles.appBar, basicStyles.lightBoxShadow, basicStyles.appBarShift)}
                elevation={0}
                position="fixed"
            >
                <Toolbar className={basicStyles.toolBar}>
                    <Box zIndex={1}>
                        <IconButton className={commonStyles.primary2} onClick={goToView}>
                            <ArrowBackIosIcon className={commonStyles.bigFontSize} />
                        </IconButton>
                    </Box>
                    <Box display="flex" justifyContent="center" position="absolute" pr={4} width="100%">
                        <Typography className={cs(commonStyles.bigFontSize)}>
                            {t('purchaseTransactionsPage:vehicleDiagram.title')}
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>
        );
    }

    return (
        <Box alignItems="center" className={commonStyles.header} display="flex">
            <Typography className={commonStyles.title}>{t('purchaseTransactionsPage:vehicleDiagram.title')}</Typography>
            <Box ml="auto">
                <Box className={commonStyles.buttonGroup}>
                    <Button color="secondary" onClick={goToView} size="large" variant="outlined">
                        {t('common:cancel')}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default VehicleDiagramHeader;
